/**
 * @fileoverview gRPC-Web generated client stub for dashboard
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: dashboard/dashboard.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.dashboard = require('./dashboard_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dashboard.DashboardServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.dashboard.DashboardServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.GetDashboardRequest,
 *   !proto.dashboard.Dashboard>}
 */
const methodDescriptor_DashboardService_GetDashboard = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/GetDashboard',
  grpc.web.MethodType.UNARY,
  proto.dashboard.GetDashboardRequest,
  proto.dashboard.Dashboard,
  /**
   * @param {!proto.dashboard.GetDashboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Dashboard.deserializeBinary
);


/**
 * @param {!proto.dashboard.GetDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Dashboard)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Dashboard>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.getDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboard,
      callback);
};


/**
 * @param {!proto.dashboard.GetDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Dashboard>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.getDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.ListDashboardsRequest,
 *   !proto.dashboard.ListDashboardsResponse>}
 */
const methodDescriptor_DashboardService_ListDashboards = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/ListDashboards',
  grpc.web.MethodType.UNARY,
  proto.dashboard.ListDashboardsRequest,
  proto.dashboard.ListDashboardsResponse,
  /**
   * @param {!proto.dashboard.ListDashboardsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.ListDashboardsResponse.deserializeBinary
);


/**
 * @param {!proto.dashboard.ListDashboardsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.ListDashboardsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.ListDashboardsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.listDashboards =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/ListDashboards',
      request,
      metadata || {},
      methodDescriptor_DashboardService_ListDashboards,
      callback);
};


/**
 * @param {!proto.dashboard.ListDashboardsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.ListDashboardsResponse>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.listDashboards =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/ListDashboards',
      request,
      metadata || {},
      methodDescriptor_DashboardService_ListDashboards);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.CreateDashboardRequest,
 *   !proto.dashboard.Dashboard>}
 */
const methodDescriptor_DashboardService_CreateDashboard = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/CreateDashboard',
  grpc.web.MethodType.UNARY,
  proto.dashboard.CreateDashboardRequest,
  proto.dashboard.Dashboard,
  /**
   * @param {!proto.dashboard.CreateDashboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Dashboard.deserializeBinary
);


/**
 * @param {!proto.dashboard.CreateDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Dashboard)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Dashboard>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.createDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/CreateDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_CreateDashboard,
      callback);
};


/**
 * @param {!proto.dashboard.CreateDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Dashboard>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.createDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/CreateDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_CreateDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.UpdateDashboardRequest,
 *   !proto.dashboard.Dashboard>}
 */
const methodDescriptor_DashboardService_UpdateDashboard = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/UpdateDashboard',
  grpc.web.MethodType.UNARY,
  proto.dashboard.UpdateDashboardRequest,
  proto.dashboard.Dashboard,
  /**
   * @param {!proto.dashboard.UpdateDashboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Dashboard.deserializeBinary
);


/**
 * @param {!proto.dashboard.UpdateDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Dashboard)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Dashboard>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.updateDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/UpdateDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_UpdateDashboard,
      callback);
};


/**
 * @param {!proto.dashboard.UpdateDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Dashboard>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.updateDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/UpdateDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_UpdateDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.DeleteDashboardRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DashboardService_DeleteDashboard = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/DeleteDashboard',
  grpc.web.MethodType.UNARY,
  proto.dashboard.DeleteDashboardRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dashboard.DeleteDashboardRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dashboard.DeleteDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.deleteDashboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/DeleteDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_DeleteDashboard,
      callback);
};


/**
 * @param {!proto.dashboard.DeleteDashboardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.deleteDashboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/DeleteDashboard',
      request,
      metadata || {},
      methodDescriptor_DashboardService_DeleteDashboard);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.AddWidgetRequest,
 *   !proto.dashboard.Widget>}
 */
const methodDescriptor_DashboardService_AddWidget = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/AddWidget',
  grpc.web.MethodType.UNARY,
  proto.dashboard.AddWidgetRequest,
  proto.dashboard.Widget,
  /**
   * @param {!proto.dashboard.AddWidgetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Widget.deserializeBinary
);


/**
 * @param {!proto.dashboard.AddWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Widget)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Widget>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.addWidget =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/AddWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_AddWidget,
      callback);
};


/**
 * @param {!proto.dashboard.AddWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Widget>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.addWidget =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/AddWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_AddWidget);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.DeleteWidgetRequest,
 *   !proto.dashboard.Dashboard>}
 */
const methodDescriptor_DashboardService_DeleteWidget = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/DeleteWidget',
  grpc.web.MethodType.UNARY,
  proto.dashboard.DeleteWidgetRequest,
  proto.dashboard.Dashboard,
  /**
   * @param {!proto.dashboard.DeleteWidgetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Dashboard.deserializeBinary
);


/**
 * @param {!proto.dashboard.DeleteWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Dashboard)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Dashboard>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.deleteWidget =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/DeleteWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_DeleteWidget,
      callback);
};


/**
 * @param {!proto.dashboard.DeleteWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Dashboard>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.deleteWidget =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/DeleteWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_DeleteWidget);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.UpdateWidgetRequest,
 *   !proto.dashboard.Widget>}
 */
const methodDescriptor_DashboardService_UpdateWidget = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/UpdateWidget',
  grpc.web.MethodType.UNARY,
  proto.dashboard.UpdateWidgetRequest,
  proto.dashboard.Widget,
  /**
   * @param {!proto.dashboard.UpdateWidgetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Widget.deserializeBinary
);


/**
 * @param {!proto.dashboard.UpdateWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Widget)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Widget>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.updateWidget =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/UpdateWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_UpdateWidget,
      callback);
};


/**
 * @param {!proto.dashboard.UpdateWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Widget>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.updateWidget =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/UpdateWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_UpdateWidget);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.MoveWidgetRequest,
 *   !proto.dashboard.Dashboard>}
 */
const methodDescriptor_DashboardService_MoveWidget = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/MoveWidget',
  grpc.web.MethodType.UNARY,
  proto.dashboard.MoveWidgetRequest,
  proto.dashboard.Dashboard,
  /**
   * @param {!proto.dashboard.MoveWidgetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Dashboard.deserializeBinary
);


/**
 * @param {!proto.dashboard.MoveWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Dashboard)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Dashboard>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.moveWidget =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/MoveWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_MoveWidget,
      callback);
};


/**
 * @param {!proto.dashboard.MoveWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Dashboard>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.moveWidget =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/MoveWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_MoveWidget);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.GetWidgetRequest,
 *   !proto.dashboard.Widget>}
 */
const methodDescriptor_DashboardService_GetWidget = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/GetWidget',
  grpc.web.MethodType.UNARY,
  proto.dashboard.GetWidgetRequest,
  proto.dashboard.Widget,
  /**
   * @param {!proto.dashboard.GetWidgetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.Widget.deserializeBinary
);


/**
 * @param {!proto.dashboard.GetWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.Widget)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.Widget>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.getWidget =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/GetWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetWidget,
      callback);
};


/**
 * @param {!proto.dashboard.GetWidgetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.Widget>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.getWidget =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/GetWidget',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetWidget);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.GetDashboardFilterValuesRequest,
 *   !proto.dashboard.GetDashboardFilterValuesResponse>}
 */
const methodDescriptor_DashboardService_GetDashboardFilterValues = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/GetDashboardFilterValues',
  grpc.web.MethodType.UNARY,
  proto.dashboard.GetDashboardFilterValuesRequest,
  proto.dashboard.GetDashboardFilterValuesResponse,
  /**
   * @param {!proto.dashboard.GetDashboardFilterValuesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.GetDashboardFilterValuesResponse.deserializeBinary
);


/**
 * @param {!proto.dashboard.GetDashboardFilterValuesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.GetDashboardFilterValuesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.GetDashboardFilterValuesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.getDashboardFilterValues =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboardFilterValues',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboardFilterValues,
      callback);
};


/**
 * @param {!proto.dashboard.GetDashboardFilterValuesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.GetDashboardFilterValuesResponse>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.getDashboardFilterValues =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboardFilterValues',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboardFilterValues);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.dashboard.GetReportingChildAccountsResponse>}
 */
const methodDescriptor_DashboardService_GetReportingChildAccounts = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/GetReportingChildAccounts',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.dashboard.GetReportingChildAccountsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.GetReportingChildAccountsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.GetReportingChildAccountsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.GetReportingChildAccountsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.getReportingChildAccounts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/GetReportingChildAccounts',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetReportingChildAccounts,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.GetReportingChildAccountsResponse>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.getReportingChildAccounts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/GetReportingChildAccounts',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetReportingChildAccounts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.GetDashboardLiveCountsRequest,
 *   !proto.dashboard.GetDashboardLiveCountsResponse>}
 */
const methodDescriptor_DashboardService_GetDashboardLiveCounts = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/GetDashboardLiveCounts',
  grpc.web.MethodType.UNARY,
  proto.dashboard.GetDashboardLiveCountsRequest,
  proto.dashboard.GetDashboardLiveCountsResponse,
  /**
   * @param {!proto.dashboard.GetDashboardLiveCountsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.GetDashboardLiveCountsResponse.deserializeBinary
);


/**
 * @param {!proto.dashboard.GetDashboardLiveCountsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.GetDashboardLiveCountsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.GetDashboardLiveCountsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.getDashboardLiveCounts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboardLiveCounts',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboardLiveCounts,
      callback);
};


/**
 * @param {!proto.dashboard.GetDashboardLiveCountsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.GetDashboardLiveCountsResponse>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.getDashboardLiveCounts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboardLiveCounts',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboardLiveCounts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.SaveDashboardLayoutRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_DashboardService_SaveDashboardLayout = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/SaveDashboardLayout',
  grpc.web.MethodType.UNARY,
  proto.dashboard.SaveDashboardLayoutRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.dashboard.SaveDashboardLayoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.dashboard.SaveDashboardLayoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.saveDashboardLayout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/SaveDashboardLayout',
      request,
      metadata || {},
      methodDescriptor_DashboardService_SaveDashboardLayout,
      callback);
};


/**
 * @param {!proto.dashboard.SaveDashboardLayoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.saveDashboardLayout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/SaveDashboardLayout',
      request,
      metadata || {},
      methodDescriptor_DashboardService_SaveDashboardLayout);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dashboard.GetDashboardLayoutRequest,
 *   !proto.dashboard.GetDashboardLayoutResponse>}
 */
const methodDescriptor_DashboardService_GetDashboardLayout = new grpc.web.MethodDescriptor(
  '/dashboard.DashboardService/GetDashboardLayout',
  grpc.web.MethodType.UNARY,
  proto.dashboard.GetDashboardLayoutRequest,
  proto.dashboard.GetDashboardLayoutResponse,
  /**
   * @param {!proto.dashboard.GetDashboardLayoutRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.dashboard.GetDashboardLayoutResponse.deserializeBinary
);


/**
 * @param {!proto.dashboard.GetDashboardLayoutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dashboard.GetDashboardLayoutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dashboard.GetDashboardLayoutResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.dashboard.DashboardServiceClient.prototype.getDashboardLayout =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboardLayout',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboardLayout,
      callback);
};


/**
 * @param {!proto.dashboard.GetDashboardLayoutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dashboard.GetDashboardLayoutResponse>}
 *     Promise that resolves to the response
 */
proto.dashboard.DashboardServicePromiseClient.prototype.getDashboardLayout =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/dashboard.DashboardService/GetDashboardLayout',
      request,
      metadata || {},
      methodDescriptor_DashboardService_GetDashboardLayout);
};


module.exports = proto.dashboard;

